import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AppService} from "../../../shared/services/app.service";
import {SiteService} from "../../../shared/services/site.service";
import {HttpClient} from "@angular/common/http";
import {H} from "../../../shared/helpers/H";
import {globalEconGroupedBarsLayout} from "./plots";
import {Action, ActionEconomyPerAgent} from "../../../shared/models/Action.model";
import {K} from "../../../shared/models/K";
import {PlotlyService} from "angular-plotly.js";
import {SiteTariffConfig, SiteTariffData, TariffAgentUnit} from "../../../shared/models/models";
import {Plotly} from "angular-plotly.js/lib/plotly.interface";
import {boolean} from "mathjs";


@Component({
    selector: 'monitor-econ',
    template: `
        <div fxLayout="column" class="full-width h100 h-100">
            <div fxLayout="row" class=" ">
                <div fxLayout="column" fxFlex="300px">
                    <mat-card class="p-4 m-4">
                        <h3>Selection des bâtiments </h3>
                        <div class="p-4">
                            <button mat-raised-button class="btn-xs" (click)="selectAllBat()">Select all</button>
                            <button mat-raised-button class="ml-4 btn-xs" (click)="deSelectAllBat()">DeSelect all</button>
                        </div>
                        <div class="scroller">
                            <div *ngFor="let batKV of batimentsMap|keyvalue" (click)="toggleBatiment(batKV.key)">
                                <mat-checkbox [checked]="batimentsToWatchMap.get(batKV.key)"></mat-checkbox>
                                {{ batKV.key }} {{ batKV.value }}
                            </div>
                        </div>
                    </mat-card>
                </div>
                <div fxLayout="row wrap" fxFlex="50" fxLayoutAlign="start start">
                    <div fxFlex="100">
                        <mat-card fxLayout="row" fxFlexAlign="center" class=" title-panel">
                            <span fxFlex>Evolution des economies <span class="text-muted m-8" *ngIf="cumul">(Cumulé)</span></span>
                            <mat-checkbox class="mr-4" [(ngModel)]="avecDerive" (change)="scanActions()">Avec dérive</mat-checkbox>
                            <mat-checkbox [(ngModel)]="cumul" (change)="getStats()">Cumulé</mat-checkbox>
                        </mat-card>
                    </div>
                    <div fxFlex="66" class="p-0 m-0">
                        <mat-card class="p-4 m-4">
                            <div id="plot-carbon"></div>
                        </mat-card>
                    </div>

                    <div *ngFor="let ag of unitAgents" fxFlex="33" class="p-0 m-0">
                        <mat-card class="p-4 m-4">
                            <div [id]="'plot-'+ag.full_label" id="plot-{{ag.full_label}}"></div>
                        </mat-card>
                    </div>

                </div>
                <div fxLayout="column" fxFlex fxLayoutAlign="space-between none">
                    <mat-card class="p-0 m-4" *ngIf="availableYears&&availableYears.length>0">
                        <div fxLayout="row" class="p-4 but-holder">
                            <button mat-raised-button class="btn-xs-25 mr-4" [class.active]="selectedYear===y"
                                    *ngFor="let y of availableYears" (click)="filterEconomiesPerYear(y)">
                                {{ y }}
                            </button>
                            <div fxFlex></div>
                            <button mat-raised-button color="primary" (click)="downloadCSV()" class="btn-xs">
                                Download CSV
                            </button>
                            <button mat-raised-button color="primary" (click)="filterEconomiesPerAgentAndYearAndUnit(0,null,null)" class="btn-xs">
                                Show all
                            </button>
                        </div>
                        <div fxLayout="row" class="p-4">
                            <button mat-raised-button class="btn-xs-25 mr-4"
                                    [title]="ag"
                                    [class.active]="selectedAgent===ag"
                                    *ngFor="let ag of unitAgents" (click)="filterEconomiesPerAgent(ag.agent,ag.unit)">
                                {{ myapp.k.EnergyAgentsDisplayNames[ag.agent] }} {{ myapp.k.unitShort[ag.unit] }}
                            </button>
                        </div>
                        <div class="all-economies-table-holder">

                            <!-- Header Table -->
                            <table class="all-economies-table header-table">
                                <tr class="head">
                                    <td class="td1">i</td>
                                    <td class="title td2">Batiment</td>
                                    <td class="td3">APE: Num (année)</td>
                                    <td class="td4">Fluide | Agent</td>
                                    <td class="td5">Libellé</td>
                                    <td class="tdSep"></td>
                                    <td class="td6">Tariff</td>
                                    <td class="td7">Éco. MWh</td>
                                    <td class="td8">Éco. Fr.</td>
                                    <td class="td9">tCO₂</td>
                                </tr>
                                <tr *ngFor="let econ of economiesToShow" (click)="myapp.showConsole(econ)">
                                    <td class="td1">{{ econ.index }}</td>
                                    <td class="title td2">{{ econ.ref }}</td>
                                    <td class="td3">APE: {{ econ.ape }} ({{ econ.year }})</td>
                                    <td class="td4">{{ econ.fluid }} | {{ econ.agent_label }}</td>
                                    <td class="td5">{{ econ.label }}</td>
                                    <td class="tdSep"></td>
                                    <td class="td6">{{ econ.price }} {{ econ.price_unit }}</td>
                                    <td class="td7">{{ econ.amount.value| number: '1.3-3' }}</td>
                                    <!--- {{ econ.econ_unit }} -->
                                    <td class="td8">{{ econ.econ_chf|currency }}</td>
                                    <td class="td9">{{ econ.emitted| number: '1.3-3' }}</td>
                                </tr>
                                <tr class="totals-row">
                                    <td colspan="7" class="td7">Totaux</td>
                                    <td class="td7">
                                        {{ calculateTotalEnergySavings() | number }}
                                    </td>
                                    <td class="td8">
                                        {{ calculateTotalFinancialSavings() | currency }}
                                    </td>
                                    <td class="td9">
                                        {{ calculateTotalCO2() | number }}
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </mat-card>
                </div>
            </div>
        </div>
    `,
    styleUrls: ['./manager.component.scss']
})
export class MonitorEconComponent implements OnInit, OnDestroy {
    protected readonly globalEconGroupedBarsLayout = globalEconGroupedBarsLayout;
    allActions: Action[] = [];
    allEconomies: any[] = [];
    allUsages: any[] = [];
    years: number[] = [];
    statsMapEconomies: Map<string, number> = new Map<string, number>();
    statsMapConsomation: Map<string, number> = new Map<string, number>();
    emitionMap: Map<string, number> = new Map<string, number>();
    batimentsMap: Map<string, number> = new Map<string, number>();
    batimentsToWatchMap: Map<string, boolean> = new Map<string, boolean>();
    // usageByTariffMap: Map<string, any> = new Map<string, any>();

    cumul = false;
    avecDerive = true;
    unitAgents: TariffAgentUnit [] = [];
    economiesToShow: any [] = [];
    baseBarTrace = {
        x: [],
        y: [],
        name: 'Chaleur',
        type: 'bar',
        barmode: 'group',
        yaxis: 'y',
        marker: {
            color: []
        }
    };
    availableYears = [];
    selectedYear = 0;
    selectedAgent = "";
    selectedUnit = "";
    unitAgentMap = {};

    get selectedBatiments() {
        const refList = [];
        this.batimentsToWatchMap.forEach((v, k) => {
            if (v) {
                refList.push(k);
            }
        });
        return refList;
    }

    constructor(
        public myapp: AppService,
        public site: SiteService,
        private http: HttpClient
    ) {

    }

    ngOnInit(): void {
        if (this.myapp.user) {
            // this.preRun();
            this.run();
        } else {
            this.myapp.appInitStatus.subscribe(step => {
                if (step === 3) {
                    this.run();
                }
            });
        }
    }

    preRun() {
        if (this.myapp.user && this.myapp.user.isAdmin) {
            this.run();
        } else {
            this.myapp.showError("Accès reservé aux administrateurs");
            setTimeout(() => {
                window.history.back();
            }, 4000);
        }
    }

    run() {
        this.myapp.storeCurrentRoute();
        this.site.api.getAllActions(this.myapp.user.email).subscribe(resp => {
            if (Array.isArray(resp.body)) {
                this.allActions = resp.body.map(it => new Action(it));
                // console.log("Actions recues", this.allActions.length);
                this.allActions.forEach(act => {
                    // console.log("Actions recues", act._ref, act._gc, act._exclude_calc_eco);
                });
                this.allActions = this.allActions.filter(it => it._exclude_calc_eco === 0);
            }
            this.scanActions();
        });
    }

    // populate allEconomies array
    scanActions() {
        let counter = 1;
        // this.usageByTariffMap = new Map<string, any>();
        this.allEconomies = [];
        this.allActions.forEach(act => {
            act.economies.forEach(econ => {
                const econObj = new ActionEconomyPerAgent(econ);

                const tariffKeyForRefYear = act._tariff_data['year_ref'] + '-' + econ.uid_tariff;

                const econObjectWithTarif = {...econ};
                const tariffObj = new SiteTariffConfig(act._tariff_data['tariff_config'][econ.uid_tariff]);
                const agent = tariffObj.agent !== 'NOAGENT' ? tariffObj.agent : 'WATER';
                econ.agent = agent;
                econ.unit = tariffObj.unit;

                this.unitAgentMap[tariffObj.agent] = this.myapp.k.unitShort[tariffObj.unit];
                this.unitAgents.push(new TariffAgentUnit(econ.agent, econ.unit));

                let tariffDataObj: SiteTariffData = null;
                if (act._tariff_data['energy_usage'][tariffKeyForRefYear]) {
                    tariffDataObj = new SiteTariffData(act._tariff_data['energy_usage'][tariffKeyForRefYear]);
                }

                econObjectWithTarif['index'] = counter;
                econObjectWithTarif['ref'] = act._tariff_data['ref'];
                econObjectWithTarif['ape'] = act.num;
                econObjectWithTarif['year'] = act.yearTerminated;
                econObjectWithTarif['tariffObj'] = tariffObj;
                econObjectWithTarif['fluid'] = tariffObj.fluid;
                econObjectWithTarif['agent'] = econ.agent;
                econObjectWithTarif['amount'] = econObj.renderAmount(econObj.econEstimated);
                // special fields
                econObjectWithTarif['agent_label'] = K.EnergyAgentsDisplayNames[tariffObj.agent];
                econObjectWithTarif['agent_unit'] = econ.agent + econ.unit;
                econObjectWithTarif['econ_unit'] = tariffObj.unitStr;
                econObjectWithTarif['price_unit'] = tariffObj.priceUnitStr;

                if (tariffDataObj) {
                    econObjectWithTarif['econ'] = econObj.econEstimated || 0;
                    econObjectWithTarif['econ_chf'] = econObj.economyInChf(tariffObj, tariffDataObj);
                    econObjectWithTarif['price'] = tariffDataObj.priceAdapted;
                    econObjectWithTarif['emitted'] = tariffDataObj.getCegesEmittedForInput(econObj.econEstimated) || 0;
                } else {
                    console.log("Pas de tariffObj", econObjectWithTarif['ref'], econObjectWithTarif['ape'], tariffObj);
                }
                // if (econObjectWithTarif['econ'] > 0 && act.yearTerminated > 2016) {
                if (act.yearTerminated > 2016) {
                    if (this.avecDerive) {
                        this.availableYears.push(act.yearTerminated);
                        this.allEconomies.push(econObjectWithTarif);
                    } else {
                        if (econObjectWithTarif['econ'] > 0) {
                            this.availableYears.push(act.yearTerminated);
                            this.allEconomies.push(econObjectWithTarif);
                        }
                    }
                }
                if (econObjectWithTarif['econ'] <= 0) {
                    console.log("Err", "Economie négative", econObjectWithTarif['ref'], econObjectWithTarif);
                }
                counter++;


                this.batimentsToWatchMap.set(econObjectWithTarif['ref'], true);
                H.incrStatMap(this.batimentsMap, econObjectWithTarif['ref'], 1);
            });
        });
        // console.log(" this.usageByTariffMap: ", this.usageByTariffMap);
        this.availableYears = H.arrayUnique(this.availableYears).sort();
        this.unitAgents = H.arrayUniqueByHash(this.unitAgents)
            .sort((v1, v2) => v1.full_label.localeCompare(v2.full_label));

        this.getStats();
    }

    populateTariffs(act: Action) {
        Object.keys(act._tariff_data['energy_usage']).forEach((k, i) => {
            const _tariffDataObj = act._tariff_data['energy_usage'][k];
            const _tariffObj = new SiteTariffConfig(act._tariff_data['tariff_config'][_tariffDataObj.uid_tariff]);
            _tariffDataObj['ref'] = act._tariff_data['ref'];
            _tariffDataObj['parent_tariff'] = act._tariff_data['tariff_config'][_tariffDataObj.uid_tarif];
            // this.usageByTariffMap.set(k + act._tariff_data['ref'], H.sortObjectByKeys(_tariffDataObj));
            // this.usageByTariffMap.set(k + act._tariff_data['ref'] + "-Config", H.sortObjectByKeys(_tariffObj));
            if (!_tariffDataObj['parent_tariff']) {
                // console.log("ErrX1-->", _tariffDataObj, k, i, act._tariff_data, _tariffDataObj);
                // console.log("ErrX-->", _tariffDataObj['ref'], act.num, k, act._tariff_data['tariff_config'], _tariffDataObj);
            } else {
                // console.log("OK-->", _tariffDataObj['ref'], act.num, act._tariff_data['tariff_config'], _tariffDataObj);
                // console.log("OK-->",k + act._tariff_data['ref'], this.usageByTariffMap);
            }
        });
    }

    // populate stats maps
    getStats() {
        this.statsMapEconomies = new Map<string, number>();
        this.statsMapConsomation = new Map<string, number>();
        this.emitionMap = new Map<string, number>();

        // console.log("--> Get stat statsMapEconomies", this.statsMapEconomies);
        this.allEconomies
            .filter(econ => this.selectedBatiments.includes(econ.ref))
            .forEach(economies => {
                const key = economies['year'] + "_" + economies['agent_unit'];
                H.incrStatMap(this.statsMapEconomies, key, economies['econ']);
                H.incrStatMap(this.emitionMap, economies['year'].toString(), economies['emitted']);
                // console.log("--> Get stat", key, economies['econ']);
            });

        // create empty item for every compo agent/year to avoid skipping bars in plot
        this.availableYears.forEach(y => {
            this.unitAgents.forEach(ag => {
                const key = y + "_" + ag.full_label;
                H.incrStatMap(this.statsMapEconomies, key, 0);
                H.incrStatMap(this.emitionMap, y.toString(), 0);
            });
        });
        this.renderEnergyPlots();
        this.renderCarbonPlot();


    }

    renderEnergyPlots() {
        console.log("Agent unit", this.unitAgents);
        const tracesHolder = {};
        this.statsMapEconomies = new Map([...this.statsMapEconomies.entries()].sort());
        const prevY = {};
        this.statsMapEconomies.forEach((v, k) => {
            const agent = k.split(/_(.*)/s)[1];
            const year = Number(k.split(/_(.*)/s)[0]);

            // console.log("kk", k, v);
            if (!tracesHolder[agent]) {
                const trace = JSON.parse(JSON.stringify(this.baseBarTrace));
                trace.name = agent;
                tracesHolder[agent] = trace;
            }
            let correctedValue = v;
            /// todo: adapt
            if (agent !== "WATER" && agent !== "EAU") {
                correctedValue = correctedValue / 1e6;
            }
            tracesHolder[agent]['name'] = agent;
            tracesHolder[agent].x.push(year);
            if (!prevY[agent]) {
                prevY[agent] = 0;
            }
            if (this.cumul)
                prevY[agent] += correctedValue;
            else
                prevY[agent] = correctedValue;

            if (year === this.selectedYear) {
                tracesHolder[agent].marker.color.push('#ff7f0e');
            } else {
                tracesHolder[agent].marker.color.push('#6666FF');
            }
            tracesHolder[agent].y.push(prevY[agent]);

        });

        // console.log("tracesHolder", tracesHolder);

        setTimeout(() => {
            this.unitAgents.forEach((ag, index) => {
                const agentTraces = Object.values(tracesHolder).filter(trace => trace['name'] === ag.full_label);
                const agentLayout = {...this.globalEconGroupedBarsLayout};
                agentLayout.yaxis.title = this.unitAgentMap[ag.agent];
                console.log("setTimeout", this.unitAgentMap[ag.agent], ag, this.unitAgentMap);
                agentLayout.title.text = "Economies de: " + this.myapp.k.EnergyAgentsDisplayNames[ag.agent];
                // @ts-ignore
                Plotly.newPlot(`plot-${ag.full_label}`, agentTraces, agentLayout, {
                    ...this.myapp.k.defaultConfig,
                    responsive: false,
                    displayModeBar: false,
                }).then(gd => {
                    gd.on('plotly_click', (data) => {
                        console.log('Clicked:', {agent: ag, year: data.points[0].x});
                        this.filterEconomiesPerAgentAndYearAndUnit(data.points[0].x, ag.agent, ag.unit);
                        this.getStats();
                    });
                });
            });

        }, 100);
    }

    renderCarbonPlot() {
        const tracesHolder = JSON.parse(JSON.stringify(this.baseBarTrace));
        this.emitionMap = new Map([...this.emitionMap.entries()].sort());
        let prevY = 0;
        this.emitionMap.forEach((v, k) => {
            const agent = k.split(/_(.*)/s)[1];
            const year = Number(k.split(/_(.*)/s)[0]);

            const correctedValue = v;
            tracesHolder['name'] = agent;
            tracesHolder.x.push(year);

            if (this.cumul)
                prevY += correctedValue;
            else
                prevY = correctedValue;

            if (year === this.selectedYear) {
                tracesHolder.marker.color.push('#ff7f0e');
            } else {
                tracesHolder.marker.color.push('#6666FF');
            }
            tracesHolder.y.push(prevY);

        });
        const carbonLayout = {...this.globalEconGroupedBarsLayout};
        carbonLayout.width = 800;
        carbonLayout['yaxis'] = {...carbonLayout.yaxis, title: "tCO2"};
        carbonLayout['title'] = {x: 0.02, text: "Emission de carbone"};
        setTimeout(() => {
            // @ts-ignore
            Plotly.newPlot("plot-carbon", [tracesHolder], carbonLayout, this.myapp.k.defaultConfig);
        }, 5);
    }

    // filtering for right pane list
    filterEconomiesPerAgentAndYearAndUnit(year: number, agent: string, unit: string) {
        this.selectedAgent = agent;
        this.selectedYear = year;
        this.economiesToShow = this.allEconomies
            .filter(econ => this.selectedBatiments.includes(econ.ref))
            .filter(econ => (year ? econ.year === year : econ.year > 0) && (agent ? econ.agent === agent : econ.agent !== ''));
    }

    filterEconomiesPerYear(year: number) {
        console.log("filterEconomies", year);
        this.selectedYear = year;
        this.filterEconomiesPerAgentAndYearAndUnit(this.selectedYear, this.selectedAgent, this.selectedUnit);
    }

    filterEconomiesPerAgent(agent: string, unit: string) {
        this.selectedAgent = agent;
        this.selectedUnit = unit;
        console.log("filterEconomiesPerAgent", agent);
        this.filterEconomiesPerAgentAndYearAndUnit(this.selectedYear, this.selectedAgent, this.selectedUnit);
    }

    // calc total row
    calculateTotalEnergySavings(): number {
        return this.economiesToShow.reduce((total, econ) => {
            const value = Number(econ.amount?.value) || 0;
            return total + value;
        }, 0);
    }

    calculateTotalFinancialSavings(): number {
        return this.economiesToShow.reduce((total, econ) => {
            const value = Number(econ.econ_chf) || 0;
            return total + value;
        }, 0);
    }

    calculateTotalCO2(): number {
        return this.economiesToShow.reduce((total, econ) => {
            const value = Number(econ.emitted) || 0;
            return total + value;
        }, 0);
    }

    toggleBatiment(ref: string) {
        console.log("toggleBatiment", ref);
        const currValue = this.batimentsToWatchMap.get(ref);
        this.batimentsToWatchMap.set(ref, !currValue);
        this.getStats();
    }

    selectAllBat() {
        this.batimentsToWatchMap.forEach((v, k) => {
            this.batimentsToWatchMap.set(k, true);
        });
        this.getStats();
    }

    deSelectAllBat() {
        this.batimentsToWatchMap.forEach((v, k) => {
            this.batimentsToWatchMap.set(k, false);
        });
        this.getStats();
    }

    downloadCSV() {
        if (!this.allEconomies.length) {
            this.myapp.showError("No data to export");
            return;
        }

        const economiesSanitized = this.allEconomies.map(e => ({
            Index: e.index || '',
            Building: e.ref || '',
            ApeNumber: e.ape || '',
            Year: e.year || '',
            Fluid: e.fluid || '',
            Agent: e.agent_label || e.agent || '',
            Label: e.label || '',
            Tariff: e.price ? Number(e.price).toFixed(3) : '',
            EnergySavings: e.amount?.value ? Number(e.amount.value).toFixed(3) : '',
            Unit: e.econ_unit || '',
            FinancialSavings: e.econ_chf ? Number(e.econ_chf).toFixed(2) : '',
            CO2Emissions: e.emitted ? Number(e.emitted).toFixed(4) : ''
        }));

        const exportData = {
            economies: economiesSanitized,
            totals: {
                energySavings: this.calculateTotalEnergySavings(),
                financialSavings: this.calculateTotalFinancialSavings(),
                co2: this.calculateTotalCO2()
            }
        };
        console.log("exportData", exportData);
        this.myapp.loader.open("Génération de csv");
        this.http.post('https://api.optimise.swiss/endpoint/economic-data-to-csv', exportData, {
            responseType: 'blob',
            headers: {'Content-Type': 'application/json'}
        }).subscribe({
            next: (response: Blob) => {
                const url = window.URL.createObjectURL(response);
                const link = document.createElement('a');
                link.href = url;
                link.download = `economies-data-${new Date().toISOString().slice(0, 10)}.csv`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                this.myapp.loader.close();
            },
            error: err => {
                console.error('Error downloading CSV:', err);
                this.myapp.showError('Error downloading CSV file');
                this.myapp.loader.close();
            }
        });
    }

    ngOnDestroy() {
    }

}
